module.exports = __webpack_public_path__ + "static/media/twitter-icon.6925cfc0.svg";